/* GAP */
var compTab = {
  1: [{
    codigo: 'A11101',
    bandas: [1,0,0,0,0,0,0,0],
    calculo: [1,0,0,0,0,0,0,0],
    edit: false,
    eval: false
  }],
  2: [{
    codigo: 'A11102',
    bandas: [1,0,0,0,0,0,0,0],
    calculo: [1,0,0,0,0,0,0,0],
    edit: false,
    eval: false
  }],
  3: [{
    codigo: 'A11103',
    valBan: 'INV_01',
    bandas: [1,1,1,0,0,0,0,0],
    calculo: [1,1,1,0,0,0,0,0],
    edit: false,
    eval: false
  }],
  4: [{
    codigo: 'suma',
    bandas: [1,1,1,0,0,0,0,0],
    calculo: [1,1,1,0,0,0,0,0],
    edit: false,
    eval: false
  }],
  5: [{
    codigo: 'VT048',
    valBan: 'INV_02',
    bandas: [0,0,0,1,1,1,1,1],
    calculo: [0,0,0,1,1,1,1,1],
    edit: false,
    eval: true
  }],
  6: [{
    codigo: 'VT005',
    valBan: 'ASI_01',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    edit: false,
    eval: true
  }],
  7: [{
    codigo: 'A11204',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: 'editable_1',
    edit: true,
    eval: false
  }],
  8: [{
    codigo: 'A124',
    bandas: [0,0,0,0,0,0,0,1],
    calculo: [0,0,0,0,0,0,0,1],
    edit: false,
    eval: false
  }],
  9: [{
    codigo: 'A11203',
    bandas: [0,0,1,0,0,0,0,0],
    calculo: [0,0,1,0,0,0,0,0],
    edit: false,
    eval: false
  }],
  10: [{
    codigo: 'A12504 + VT040 + VT041 - A11204',
    descripcion: 'Resto de activos (suma de adjudicados, intangibles, diferidos y varios)',
    bandas: [0,0,0,0,0,0,0,1],
    calculo: [0,0,0,0,0,0,0,1],
    edit: false,
    eval: false
  }],
  11: [{
    codigo: 'suma',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    edit: false,
    eval: false
  }],
  12: [{
    codigo: 'VT017',
    bandas: [1,1,1,1,1,0,0,0],
    calculo: 'editable_2',
    edit: true,
    eval: false
  }],
  13: [{
    codigo: 'P211010103 + P211010104 + P211010203 + P211010204 + P221010101 + P221010102 + P221010201 + P221010202',
    valBan: 'AHO_02',
    descripcion: 'Depósitos a plazo fijo',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    edit: false,
    eval: true
  }],
  14: [{
    codigo: 'P211010105 + P211010106 + P211010205 + P211010206 + P221010103 + P221010104 + P221010203 + P221010204',
    valBan: 'AHO_09',
    descripcion: 'Otras captaciones',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    edit: false,
    eval: true
  }],
  15: [{
    codigo: 'VT025',
    valBan: 'LIQ_01',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    edit: false,
    eval: true
  }],
  16: [{
    codigo: 'VT044',
    bandas: [0,0,0,0,0,0,1,1],
    calculo: 'editable_3',
    edit: true,
    eval: false
  }],
  17: [{
    codigo: 'VT026',
    bandas: [0,0,1,0,0,0,0,0],
    calculo: [0,0,1,0,0,0,0,0],
    edit: false,
    eval: false
  }],
  18: [{
    codigo: 'P21201 + P21202 + P21204 + P22201 + P22203',
    descripcion: 'Pasivos varios',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: 'editable_4',
    edit: true,
    eval: false
  }],
  19: [{
    codigo: 'P311',
    bandas: [0,0,0,0,0,0,0,1],
    calculo: [0,0,0,0,0,0,0,1],
    edit: false,
    eval: false
  }],
  20: [{
    codigo: 'P312',
    bandas: [0,0,0,0,0,0,0,1],
    calculo: [0,0,0,0,0,0,0,1],
    edit: false,
    eval: false
  }],
  21: [{
    codigo: 'P313',
    bandas: [0,0,0,0,0,0,0,1],
    calculo: [0,0,0,0,0,0,0,1],
    edit: false,
    eval: false
  }],
  22: [{
    codigo: 'suma',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    edit: false,
    eval: false
  }],
  23: [{
    codigo: 'I4110201 / V050',
    valBan: 'ASI_02',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    descripcion: 'Intereses de cartera',
    edit: false,
    eval: false
  }],
  24: [{
    codigo: 'I4110201 / V050 + I4110102 / V050',
    prom: true,
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [7/30,8/30,15/30,1,1,90/30,180/30,360/30],
    descripcion: 'Comisiones por cobrar',
    edit: false,
    eval: false
  }],
  25: [{
    codigo: 'I4110301 / V050',
    prom: true,
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [7/30,8/30,15/30,1,1,90/30,180/30,360/30],
    descripcion: 'Intereses de depósitos a la vista',
    edit: false,
    eval: false
  }],
  26: [{
    codigo: 'I4110201 / V050',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    descripcion: 'Intereses de inversiones financieras',
    edit: false,
    eval: false
  }],
  27: [{
    codigo: 'suma',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    edit: false,
    eval: false
  }],
  28: [{
    codigo: 'I4110201 / V050',
    valBan: 'AHO_03',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [7/30,8/30,15/30,1,1,90/30,180/30,360/30],
    descripcion: 'Intereses de captaciones a la vista',
    edit: false,
    eval: false
  }],
  29: [{
    codigo: 'I4110201 / V050',
    valBan: 'AHO_04',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [7/30,8/30,15/30,1,1,90/30,180/30,360/30],
    descripcion: 'Intereses de depósitos a plazo fijo',
    edit: false,
    eval: false
  }],
  30: [{
    codigo: 'I4110201 / V050',
    valBan: 'AHO_05',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [7/30,8/30,15/30,1,1,90/30,180/30,360/30],
    descripcion: 'Intereses de otras captaciones',
    edit: false,
    eval: false
  }],
  31: [{
    codigo: 'I4110201 / V050',
    valBan: 'LIQ_02',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    descripcion: 'Intereses de crédito externo',
    edit: false,
    eval: false
  }],
  32: [{
    codigo: 'VT037 / V050',
    prom: true,
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [7/30,8/30,15/30,1,1,90/30,180/30,360/30],
    descripcion: 'Gastos de administración',
    edit: false,
    eval: false
  }],
  33: [{
    codigo: 'G5110104 / V050',
    prom: true,
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [7/30,8/30,15/30,1,1,90/30,180/30,360/30],
    descripcion: 'Comisiones por pagar',
    edit: false,
    eval: false
  }],
  34: [{
    codigo: 'suma',
    bandas: [1,1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1,1],
    edit: false,
    eval: false
  }],
}
var compTabFin = {
  1: [{
    codigo: 'A11101',
    edit: false,
    eval: true
  }],
  2: [{
    codigo: 'A11102',
    edit: false,
    eval: true
  }],
  3: [{
    codigo: 'A11103',
    edit: false,
    eval: true
  }],
  4: [{
    codigo: 'suma',
    edit: false,
    eval: true
  }],
  5: [{
    codigo: 'VT048',
    edit: false,
    eval: true
  }],
  6: [{
    codigo: 'VT005',
    edit: false,
    eval: true
  }],
  7: [{
    codigo: 'A11204',
    edit: true,
    eval: true
  }],
  8: [{
    codigo: 'A124',
    edit: false,
    eval: true
  }],
  9: [{
    codigo: 'A11203',
    edit: false,
    eval: true
  }],
  10: [{
    codigo: 'A12504 + VT040 + VT041 - A11204',
    descripcion: 'Resto de activos (suma de adjudicados, intangibles, diferidos y varios)',
    edit: false,
    eval: true
  }],
  11: [{
    codigo: 'suma',
    edit: false,
    eval: true
  }],
  12: [{
    codigo: 'VT017',
    edit: true,
    eval: true
  }],
  13: [{
    codigo: 'P211010103 + P211010104 + P211010203 + P211010204 + P221010101 + P221010102 + P221010201 + P221010202',
    descripcion: 'Depósitos a plazo fijo',
    edit: false,
    eval: true
  }],
  14: [{
    codigo: 'P211010105 + P211010106 + P211010205 + P211010206 + P221010103 + P221010104 + P221010203 + P221010204',
    descripcion: 'Otras captaciones',
    edit: false,
    eval: true
  }],
  15: [{
    codigo: 'VT025',
    edit: false,
    eval: true
  }],
  16: [{
    codigo: 'VT044',
    edit: false,
    eval: true
  }],
  17: [{
    codigo: 'VT026',
    edit: false,
    eval: true
  }],
  18: [{
    codigo: 'P21201 + P21202 + P21204 + P22201 + P22203',
    descripcion: 'Pasivos varios',
    edit: true,
    eval: true
  }],
  19: [{
    codigo: 'P311',
    edit: false,
    eval: true
  }],
  20: [{
    codigo: 'P312',
    edit: false,
    eval: true
  }],
  21: [{
    codigo: 'P313',
    edit: false,
    eval: true
  }],
  22: [{
    codigo: 'suma',
    edit: false,
    eval: true
  }],
}
var tabTotales = {
  1: [{
    tabla: 1,
    codigo: 'valor',
    name: 'Total activos menos líquidos'
  }],
  2: [{
    tabla: 3,
    codigo: 'valor',
    name: 'Total ingresos contractuales esperados'
  }],
  3: [{
    codigo: 'sumaPar',
    name: 'Total de entradas'
  }],
  4: [{
    tabla: 2,
    codigo: 'valor',
    name: 'Total pasivo y patrimonio'
  }],
  5: [{
    tabla: 4,
    codigo: 'valor',
    name: 'Total egresos contractuales esperados'
  }],
  6: [{
    codigo: 'sumaPar',
    name: 'Total de salidas'
  }],
  7: [{
    codigo: 'suma',
    name: 'GAP por tramo'
  }]
}
var opciones = [
  "de_1_7",
  "de_8_15",
  "de_16_30",
  "de_31_60",
  "de_61_90",
  "de_91_180",
  "de_181_360",
  "mas_360",
]
export class gap{
  static tabla(id){
    return compTab[id] ?? undefined;
  }
  static tablaCom(id){
    return compTabFin[id] ?? undefined;
  }
  static setTabla(id, calculo){
    compTab[id].calculo = calculo;
  }
  static tabTot(id){
    return tabTotales[id] ?? undefined;
  }
}
const cuentas = [
  'A11101',
  'A11102',
  'A11103',
  'A11204',
  'A124',
  'A11203',
  'A12504',
  'P211010103',
  'P211010104',
  'P211010203',
  'P211010204',
  'P221010101',
  'P221010102',
  'P221010201',
  'P221010202',
  'P211010105',
  'P211010106',
  'P211010205',
  'P211010206',
  'P221010103',
  'P221010104',
  'P221010203',
  'P221010204',
  'P21201',
  'P21202',
  'P21204',
  'P22201',
  'P22203',
  'P311',
  'P312',
  'P313',
  'I4110201',
  'I4110102',
  'I4110301',
  'G5110104'
];
const varTemp = [
  'VT048',
  'VT005',
  'VT040',
  'VT041',
  'VT017',
  'VT025',
  'VT044',
  'VT026',
  'VT037'
];
const cuentasProm = [
  'I4110201',
  'I4110102',
  'I4110301',
  'G5110104'
];
const varTempProm = [
  'VT037',
];
const varProm = [
  'V050',
];
export { cuentas, varTemp, cuentasProm, varTempProm, varProm, opciones  }

/* Cobertura */
const cuenta = [
  'A11101',
  'A11102',
  'P21201',
  'P21202',
  'P21204',
  'P22201',
  'P22203'
]
const variable = [
  'V007',
  'V008',
  'V009'
]
const variableTemp = [
  'VT017',
  'VT053'
]
const cuentasP = [
  'G5110104'
];
const varTP = [
  'VT037',
];
const varP = [
  'V050',
];
var tabla = {
  1: [{
    codigo: 'encabezado',
    concepto: 'A. ACTIVOS DE NIVEL 1',
  }],
  2: [{
    codigo: 'A11101 + A11102 + INV1',
    concepto: 'Activos líquidos de nivel 1',
    factor: 100
  }],
  3: [{
    codigo: 'encabezado',
    concepto: 'B. ACTIVOS DE NIVEL 2A y 2B',
  }],
  4: [{
    codigo: 'encabezado',
    concepto: '(2A+2B <=40% de los HQLA) & (2B <= 15% de los HQLA)',
  }],
  5: [{
    codigo: '',
    concepto: 'Activos líquidos en bonos de nivel 2A',
    factor: 85
  }],
  6: [{
    codigo: '',
    concepto: 'Bonos de titularización hipotecaria (2B)',
    factor: 75
  }],
  7: [{
    codigo: '',
    concepto: 'Otros activos líquidos no admisibles al 100% (2B)',
    factor: 50
  }],
  8: [{
    codigo: 'suma',
    concepto: 'Total del fondo de HQLA',
  }],
  9: [{
    codigo: 'encabezado',
    concepto: 'Captaciones a la vista',
  }],
  10: [{
    codigo: 'VT017',
    concepto: 'Dep. Vista sin seguro de depósitos',
    factor: 10
  }],
  11: [{
    codigo: '',
    concepto: 'Dep. Vista personas con seguro de depósitos',
    factor: 5
  }],
  12: [{
    codigo: 'V007 + V008 + V009',
    concepto: 'Depósitos de entidades finan. y cooperativas',
    factor: 25
  }],
  13: [{
    codigo: '',
    concepto: 'Depósitos de empresas y sector público',
    factor: 40
  }],
  14: [{
    codigo: 'VT053',
    concepto: 'Otras captaciones',
    factor: 10
  }],
  15: [{
    codigo: 'subtot',
    concepto: 'Subtotal de captaciones a la vista y otras',
  }],
  16: [{
    codigo: 'encabezado',
    concepto: 'Captaciones a plazo fijo',
  }],
  17: [{
    codigo: 'AHO_02',
    concepto: 'Depósitos a plazo con vencimiento hasta 30d.',
    factor: 100
  }],
  18: [{
    codigo: 'encabezado',
    concepto: 'Otras salidas',
  }],
  19: [{
    codigo: 'AHO_03 + AHO_04 + AHO_05',
    concepto: 'Intereses de captaciones',
    factor: 100
  }],
  20: [{
    codigo: 'LIQ_01',
    concepto: 'Capital de créditos externos con venc. hasta 30d.',
    factor: 100
  }],
  21: [{
    codigo: 'LIQ_02',
    concepto: 'Intereses de créditos externos con venc. hasta 30d.',
    factor: 100
  }],
  22: [{
    codigo: 'P21201 + P21202 + P21204 + P22201 + P22203',
    concepto: 'Cuentas por pagar con vencimiento hasta 30d.',
    factor: 100,
    gap: true
  }],
  23: [{
    codigo: 'VT037 / V050',
    concepto: 'Gastos operativos y administrativos',
    factor: 100,
    prom: true
  }],
  24: [{
    codigo: 'G5110104 / V050',
    concepto: 'Otras obligaciones con vencimiento hasta 30d.',
    factor: 100,
    prom: true
  }],
  25: [{
    codigo: '',
    concepto: 'Créditos concedidos pendientes de desembolsar.',
    factor: 5
  }],
  26: [{
    codigo: 'suma',
    concepto: 'Total de salidas de efectivo',
  }],
  27: [{
    codigo: 'ASI1',
    concepto: 'Capital de créditos con vencimiento hasta 30d.',
    factor: 50,
  }],
  28: [{
    codigo: 'ASI2',
    concepto: 'Intereses de créditos con vencimiento hasta 30d.',
    factor: 50,
  }],
  29: [{
    codigo: '',
    concepto: 'Ingresos por intereses en inversiones hasta 30d.',
    factor: 100,
  }],
  30: [{
    codigo: 'suma',
    concepto: 'Total de entradas de efectivo',
  }],
}
var tabla12 = {
  1: [{
    codigo: 'encabezado',
    concepto: 'A. ACTIVOS DE NIVEL 1',
  }],
  2: [{
    codigo: 'A101 + inversiones_1',
    concepto: 'Activos líquidos de nivel 1',
    factor: 100
  }],
  3: [{
    codigo: 'suma',
    concepto: 'Total del fondo de HQLA',
  }],
  4: [{
    codigo: 'fondeo_1',
    concepto: 'Capital de fondeo con vencimiento hasta 30días',
    factor: 100
  }],
  5: [{
    codigo: 'fondeo_2',
    concepto: 'Intereses de fondeo con vencimiento hasta 30 días',
    factor: 100
  }],
  6: [{
    codigo: 'VT09 * create_1',/// variable de alerta tremprana
    concepto: 'Otros pasivos con vencimiento hasta 30días',
    factor: 100
  }],
  7: [{
    codigo: 'create_3',
    concepto: 'Gastos operativos y administrativos de 30 días',
    factor: 100,
    manual: true
  }],
  8: [{
    codigo: 'suma',
    concepto: 'Total de salidas de efectivo',
  }],
  9: [{
    codigo: 'create_5',
    concepto: 'Capital de créditos con vencimiento hasta 30 días',
    factor: 75,
    manual: true
  }],
  10: [{
    codigo: 'create_6',
    concepto: 'Intereses de créditos con vencimiento hasta 30 días',
    factor: 75,
    manual: true
  }],
  11: [{
    codigo: 'inversiones_3',
    concepto: 'Ingresos por intereses en inversiones hasta 30 días',
    factor: 100
  }],
  12: [{
    codigo: 'suma',
    concepto: 'Total de entradas de efectivo',
  }],
}
export class cobertura{
  static cuentasAT(plantilla: number){
    var cuentas = {};
    switch(plantilla){
      case 7: 
        cuentas = {
          cuentas : [],
          varTemp: [],
          var:[]
        }
        break;
      case 12:
        cuentas = {
          cuentas : ['A101'],
          varTemp : ['VT09'],
          var:[]
        }
        break;
        
    }
    return cuentas;
  }
  static tabla(plantilla: number, id: number){
     switch(plantilla){
      case 12: 
        return tabla12[id] ?? undefined;
      case 7:
        return tabla[id] ?? undefined;
    }
  }
}
export { cuenta, variable, variableTemp, cuentasP, varTP, varP }

/* Concentración */

const perspectivas = [
  'Productos',
  'Saldo',
  'Depositos a plazo por vencimiento'
]

var tabla1Con = {
  0: [{
    descripcion: 'suma',
    monto: 'CRE_14 + CRE_15 + CRE_16 + CRE_17 + CRE_18 + CRE_19',
  }],
  1: [{
    descripcion: 'A la Vista',
    salProm: 'CRE_14 / CRE_20',
    monto: 'CRE_14',
    porcen: 'CRE_14 / suma * 100',
    lim: 'CRE_14_lim',
  }],
  2: [{
    descripcion: 'A plazo fijo',
    salProm: 'CRE_15 / CRE_21',
    monto: 'CRE_15',
    porcen: 'CRE_15 / suma * 100',
    lim: 'CRE_15_lim',
  }],
  3: [{
    descripcion: 'Especial',
    salProm: 'CRE_16 / CRE_22',
    monto: 'CRE_16',
    porcen: 'CRE_16 / suma * 100',
    lim: 'CRE_16_lim',
  }],
  4: [{
    descripcion: 'Infanto juvenil',
    salProm: 'CRE_17 / CRE_23',
    monto: 'CRE_17',
    porcen: 'CRE_17 / suma * 100',
    lim: 'CRE_17_lim',
  }],
  5: [{
    descripcion: 'Suspenso',
    salProm: 'CRE_18 / CRE_24',
    monto: 'CRE_18',
    porcen: 'CRE_18 / suma * 100',
    lim: 'CRE_18_lim',
  }],
  6: [{
    descripcion: 'Planificado',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_19',
    porcen: 'CRE_19 / suma',
    lim: 'CRE_19_lim',
  }],
}
var tabla2Con = {
  0: [{
    descripcion: 'suma',
    monto: 'CRE_20 + CRE_21 + CRE_22 + CRE_23 + CRE_24 + CRE_25',
  }],
  1: [{
    descripcion: 'A la Vista',
    salProm: 'CRE_14 / CRE_20',
    monto: 'CRE_20',
    porcen: 'CRE_20 / suma * 100',
    lim: 'CRE_20_lim',
  }],
  2: [{
    descripcion: 'A plazo fijo',
    salProm: 'CRE_15 / CRE_21',
    monto: 'CRE_21',
    porcen: 'CRE_21 / suma * 100',
    lim: 'CRE_21_lim',
  }],
  3: [{
    descripcion: 'Especial',
    salProm: 'CRE_16 / CRE_22',
    monto: 'CRE_22',
    porcen: 'CRE_22 / suma * 100',
    lim: 'CRE_22_lim',
  }],
  4: [{
    descripcion: 'Infanto juvenil',
    salProm: 'CRE_17 / CRE_23',
    monto: 'CRE_23',
    porcen: 'CRE_23 / suma * 100',
    lim: 'CRE_23_lim',
  }],
  5: [{
    descripcion: 'Suspenso',
    salProm: 'CRE_18 / CRE_24',
    monto: 'CRE_24',
    porcen: 'CRE_24 / suma * 100',
    lim: 'CRE_24_lim',
  }],
  6: [{
    descripcion: 'Planificado',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_25',
    porcen: 'CRE_25 / suma',
    lim: 'CRE_25_lim',
  }],
}

var tabla3Con = {
  0: [{
    descripcion: 'suma',
    monto: 'CRE_14 + CRE_15 + CRE_16 + CRE_17 + CRE_18 + CRE_19',
  }],
  1: [{
    descripcion: '<= a 100.000',
    salProm: 'CRE_14 / CRE_20',
    monto: 'CRE_14',
    porcen: 'CRE_14 / suma * 100',
    lim: 'CRE_14_lim',
  }],
  2: [{
    descripcion: '>100.000 a 500.000',
    salProm: 'CRE_15 / CRE_21',
    monto: 'CRE_15',
    porcen: 'CRE_15 / suma * 100',
    lim: 'CRE_15_lim',
  }],
  3: [{
    descripcion: '>500.000 a 1.000.000',
    salProm: 'CRE_16 / CRE_22',
    monto: 'CRE_16',
    porcen: 'CRE_16 / suma * 100',
    lim: 'CRE_16_lim',
  }],
  4: [{
    descripcion: '>1.000.000 a 2.000.000',
    salProm: 'CRE_17 / CRE_23',
    monto: 'CRE_17',
    porcen: 'CRE_17 / suma * 100',
    lim: 'CRE_17_lim',
  }],
  5: [{
    descripcion: '>2.000.000 a 5000.000',
    salProm: 'CRE_18 / CRE_24',
    monto: 'CRE_18',
    porcen: 'CRE_18 / suma * 100',
    lim: 'CRE_18_lim',
  }],
  6: [{
    descripcion: '>5.000.000 a 10.000.000',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_19',
    porcen: 'CRE_19 / suma',
    lim: 'CRE_19_lim',
  }],
  7: [{
    descripcion: '>10.000.000 a 20.000.000',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_19',
    porcen: 'CRE_19 / suma',
    lim: 'CRE_19_lim',
  }],
  8: [{
    descripcion: '>20.000.000 a 30.000.000',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_19',
    porcen: 'CRE_19 / suma',
    lim: 'CRE_19_lim',
  }],
  9: [{
    descripcion: '>30.000.000',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_19',
    porcen: 'CRE_19 / suma',
    lim: 'CRE_19_lim',
  }],
}
var tabla4Con = {
  0: [{
    descripcion: 'suma',
    monto: 'CRE_20 + CRE_21 + CRE_22 + CRE_23 + CRE_24 + CRE_25',
  }],
  1: [{
    descripcion: '<= a 100.000',
    salProm: 'CRE_14 / CRE_20',
    monto: 'CRE_20',
    porcen: 'CRE_20 / suma * 100',
    lim: 'CRE_20_lim',
  }],
  2: [{
    descripcion: '>100.000 a 500.000',
    salProm: 'CRE_15 / CRE_21',
    monto: 'CRE_21',
    porcen: 'CRE_21 / suma * 100',
    lim: 'CRE_21_lim',
  }],
  3: [{
    descripcion: '>500.000 a 1.000.000',
    salProm: 'CRE_16 / CRE_22',
    monto: 'CRE_22',
    porcen: 'CRE_22 / suma * 100',
    lim: 'CRE_22_lim',
  }],
  4: [{
    descripcion: '>1.000.000 a 2.000.000',
    salProm: 'CRE_17 / CRE_23',
    monto: 'CRE_23',
    porcen: 'CRE_23 / suma * 100',
    lim: 'CRE_23_lim',
  }],
  5: [{
    descripcion: '>2.000.000 a 5000.000',
    salProm: 'CRE_18 / CRE_24',
    monto: 'CRE_24',
    porcen: 'CRE_24 / suma * 100',
    lim: 'CRE_24_lim',
  }],
  6: [{
    descripcion: '>5.000.000 a 10.000.000',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_25',
    porcen: 'CRE_25 / suma',
    lim: 'CRE_25_lim',
  }],
  7: [{
    descripcion: '>10.000.000 a 20.000.000',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_25',
    porcen: 'CRE_25 / suma',
    lim: 'CRE_25_lim',
  }],
  8: [{
    descripcion: '>20.000.000 a 30.000.000',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_25',
    porcen: 'CRE_25 / suma',
    lim: 'CRE_25_lim',
  }],
  9: [{
    descripcion: '>30.000.000',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_25',
    porcen: 'CRE_25 / suma',
    lim: 'CRE_25_lim',
  }],
}

var tabla5Con = {
  0: [{
    descripcion: 'suma',
    monto: 'CRE_14 + CRE_15 + CRE_16 + CRE_17 + CRE_18 + CRE_19',
  }],
  1: [{
    descripcion: '<= a 30 días',
    salProm: 'CRE_14 / CRE_20',
    monto: 'CRE_14',
    porcen: 'CRE_14 / suma * 100',
    lim: 'CRE_14_lim',
  }],
  2: [{
    descripcion: '31 a 60 días',
    salProm: 'CRE_15 / CRE_21',
    monto: 'CRE_15',
    porcen: 'CRE_15 / suma * 100',
    lim: 'CRE_15_lim',
  }],
  3: [{
    descripcion: '61 a 90 días',
    salProm: 'CRE_16 / CRE_22',
    monto: 'CRE_16',
    porcen: 'CRE_16 / suma * 100',
    lim: 'CRE_16_lim',
  }],
  4: [{
    descripcion: '91 a 180 días',
    salProm: 'CRE_17 / CRE_23',
    monto: 'CRE_17',
    porcen: 'CRE_17 / suma * 100',
    lim: 'CRE_17_lim',
  }],
  5: [{
    descripcion: '181 a 360 días',
    salProm: 'CRE_18 / CRE_24',
    monto: 'CRE_18',
    porcen: 'CRE_18 / suma * 100',
    lim: 'CRE_18_lim',
  }],
  6: [{
    descripcion: '> 360 días',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_19',
    porcen: 'CRE_19 / suma',
    lim: 'CRE_19_lim',
  }],
}
var tabla6Con = {
  0: [{
    descripcion: 'suma',
    monto: 'CRE_20 + CRE_21 + CRE_22 + CRE_23 + CRE_24 + CRE_25',
  }],
  1: [{
    descripcion: '<= a 30 días',
    salProm: 'CRE_14 / CRE_20',
    monto: 'CRE_20',
    porcen: 'CRE_20 / suma * 100',
    lim: 'CRE_20_lim',
  }],
  2: [{
    descripcion: '31 a 60 días',
    salProm: 'CRE_15 / CRE_21',
    monto: 'CRE_21',
    porcen: 'CRE_21 / suma * 100',
    lim: 'CRE_21_lim',
  }],
  3: [{
    descripcion: '61 a 90 días',
    salProm: 'CRE_16 / CRE_22',
    monto: 'CRE_22',
    porcen: 'CRE_22 / suma * 100',
    lim: 'CRE_22_lim',
  }],
  4: [{
    descripcion: '91 a 180 días',
    salProm: 'CRE_17 / CRE_23',
    monto: 'CRE_23',
    porcen: 'CRE_23 / suma * 100',
    lim: 'CRE_23_lim',
  }],
  5: [{
    descripcion: '181 a 360 días',
    salProm: 'CRE_18 / CRE_24',
    monto: 'CRE_24',
    porcen: 'CRE_24 / suma * 100',
    lim: 'CRE_24_lim',
  }],
  6: [{
    descripcion: '> 360 días',
    salProm: 'CRE_19 / CRE_25',
    monto: 'CRE_25',
    porcen: 'CRE_25 / suma',
    lim: 'CRE_25_lim',
  }],
}
export class concentracion{
  static tablaProductos1(id){
    return tabla1Con[id] ?? undefined;
  }
  static tablaProductos2(id){
    return tabla2Con[id] ?? undefined;
  }

  static tablaSaldo1(id){
    return tabla3Con[id] ?? undefined;
  }
  static tablaSaldo2(id){
    return tabla4Con[id] ?? undefined;
  }

  static tablaDepositos1(id){
    return tabla5Con[id] ?? undefined;
  }
  static tablaDepositos2(id){
    return tabla6Con[id] ?? undefined;
  }

  static regresarVal(id){
    return indicadores[id] ?? undefined;
  }
}

var indicadores = {
  "CRE_14": {
    CRE_14: {
      limits: {
        min: 0,
        max: 0
      }
    },
  }
}

export { perspectivas }

/* Indicadores */
var indCuantas = [
  'A1110101',
  'A1110201',
  'A1110301',
  'A1110401',
  'A1210101',
  'A11101',
  'A11102',
  'A11103',
  'A11104',
  'A121',
  'A1',
  'P211010101',
  'P211010102',
  'P211010201',
  'P211010202',
  'P211010103',
  'P211010104',
  'P211010203',
  'P211010204',
  'P221010101',
  'P221010102',
  'P221010201',
  'P221010202',
  'P211010105',
  'P211010106',
  'P211010205',
  'P211010206',
  'P221010103',
  'P221010104',
  'P221010203',
  'P221010204',
  'P3',
  'P311',
  'P312',
];
var indVar = [
  'V007',
  'V008',
  'V009',
];
var indVarTem = [
  'VT005',
  'VT008',
  'VT017',
  'VT048',
  'VT042',
  'VT026',
  'VT025',
  'VT058',
];

export { indCuantas, indVar, indVarTem }

export class GAPRiesgos{
  static cuentasAT(plantilla: number){
    var cuentas = {};
    switch(plantilla){
      case 7: 
        cuentas = {
          cuentas : ['A11101','A11102','A11103','A11204','A124','A11203','A12504',
                    'P211010103','P211010104','P211010203','P211010204','P221010101',
                    'P221010102','P221010201','P221010202','P211010105','P211010106',
                    'P211010205','P211010206','P221010103','P221010104','P221010203',
                    'P221010204','P21201','P21202','P21204','P22201','P22203','P311',
                    'P312','P313','I4110201','I4110102','I4110301','G5110104'],
          varTemp: ['VT048','VT005','VT040','VT041','VT017','VT025','VT044','VT026','VT037'],
          var:[]
        }
        break;
      case 12:
        cuentas = {
          cuentas : ['A101','A102'],
          varTemp : ['VT22','VT09'],
          var:[]
        }
        break;
        
    }
    return cuentas;
  }

  static tabla(planttilla: number, id: number){
    switch(planttilla){
      case 12: 
        return compTab12[id] ?? undefined;
      case 7: 
        return compTab[id] ?? undefined;
    }
  }
  static tablaCom(planttilla: number, id: number){
    switch(planttilla){
      case 12: 
        return compTab12[id] ?? undefined;
      case 7: 
        return compTabFin[id] ?? undefined;
    }
  }
  static tabTot(id){
    return tabTotales[id] ?? undefined;
  }


}
var compTab12 = {
  1: [{
    codigo: 'A101',
    bandas: [1,0,0,0,0,0,0],
    calculo: [1,0,0,0,0,0,0],
    descripcion: 'Disponibilidades',
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  2: [{
    codigo: 'A102',
    valBan: 'inversiones_1',
    bandas: [1,0,0,0,0,0,0],
    calculo: [1,0,0,0,0,0,0],
    descripcion: 'Inversiones hasta 30 días',
    edit: false,
    eval: true,
    ingresoManual: false,
  }],
  3:[{
    codigo: 'suma',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  4: [{
    codigo: '',
    valBan: 'inversiones_2',
    bandas: [0,1,1,1,1,1,1],
    calculo: [0,1,1,1,1,1,1],
    descripcion: 'Inversiones > 30 días',
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  5: [{
    codigo: '',
    valBan: 'create_5',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    descripcion: 'Cartera neta',
    edit: false,
    eval: false,
    ingresoManual: true,
  }],
  6: [{
    codigo: '',
    bandas: [0,0,0,0,0,0,0],
    calculo: [0,0,0,0,0,0,0],
    descripcion: 'Activo fijo neto',
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  7: [{
    codigo: '',
    bandas: [0,0,0,0,0,0,0],
    calculo: [0,0,0,0,0,0,0],
    descripcion: 'Restos de activos',
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  8: [{
    codigo: 'suma',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  9: [{
    codigo: '',
    valBan: 'fondeo_1',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    descripcion: 'Fondeo',
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  10: [{
    codigo: 'VT09',
    bandas: [1,1,1,1,1,1,1],
    calculo: 'create_1',
    descripcion: 'Otros pasivos',
    edit: true,
    eval: false,
    ingresoManual: false,
  }],
  11: [{
    codigo: '',
    bandas: [0,0,0,0,0,0,0],
    calculo: [0,0,0,0,0,0,0],
    descripcion: 'Patrimonio total',
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  12: [{
    codigo: 'suma',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  13: [{
    codigo: '',
    valBan: 'create_6',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    descripcion: 'Intereses de cartera neta',
    edit: false,
    eval: false,
    ingresoManual: true,
  }],
  14: [{
    codigo: '',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    descripcion: 'Intereses de depósitos a la vista',
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  15: [{
    codigo: '',
    valBan: 'inversiones_3',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    descripcion: 'Intereses de inversiones financieras',
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  16: [{
    codigo: '',
    valBan: 'create_2',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    descripcion: 'Otros ingresos',
    edit: false,
    eval: false,
    ingresoManual: true,
  }],
  17: [{
    codigo: 'suma',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  18: [{
    codigo: '',
    valBan: 'fondeo_2',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    descripcion: 'Interes de fondeo',
    edit: false,
    eval: false,
    ingresoManual: false,
  }],
  19: [{
    codigo: '',
    valBan: 'create_3',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    descripcion: 'Gastos operativos y administrativos',
    edit: false,
    eval: false,
    ingresoManual: true,
  }],
  20: [{
    codigo: '',
    valBan: 'create_4',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    descripcion: 'Otros egresos',
    edit: false,
    eval: false,
    ingresoManual: true,
  }],
  21: [{
    codigo: 'suma',
    bandas: [1,1,1,1,1,1,1],
    calculo: [1,1,1,1,1,1,1],
    edit: false,
    eval: false,
    ingresoManual: false,
  }],

};


export class CalcesPlazos{
  static cuentasAT(plantilla){
    var cuentas;
    switch(plantilla){
      case 13:
        cuentas = {
          cuentas : ['A101101',	'A101201', 'A101103',	'A101203', 'A10210102',	'A10220102',
                    'A1021010502',	'A1022010502'],
          varTemp: [],
          var:[]
        }
        break;
    }
    return cuentas;
  }

  static tablas(plantilla){
    var composicionTablas = {};
    switch(plantilla){
      case 13:
        composicionTablas = {
          composicion: { 
            1: {mn:'A101101',	me:'A101201'},
            2: {mn:'A101103',	me:'A101203'},
            3: {mn:'A10210102',	me:'A10220102'},
            4: {mn:'A1021010502',	me:'A1022010502'},
            5: {mn: '', me:'', descripcion: 'Inversiones pignoradas', valor: 0},
            6: {mn: 'total', me: '', descripcion: 'Activos líquidos', operacion: '1 + 2 + 3 + 4 - 5'}
          },
          // activos: {
          //   1: {mn:'A101101', me:'A101201'},
          //   2: {mn:'A101103', me:'A101203'},
          //   3: {mn:'A101102', me:'A101202', valor:0},
          //   4: {mn:'A102101', me:'A102201'},
          //   5: {mn:'A102102', me:'A102202'},
          //   6: {mn:'A103101', me:'A103201'},
          //   7: {mn:'A104101', me:'A104201'},
          //   8: {mn:'A104103', me:'A104203', valor:0},
          //   9: {mn:'A104104', me:'A104204'},
          //   10: {mn:'A104105', me:'A104205'},
          //   11: {mn: 'total', me: '', descripcion: 'Total flujos activos', operacion: 'suma'}
          // },
          // pasivos: {
          //   1: {mn:'P201108',	me:'P201208', valor3190: 0},
          //   2: {mn:'P201109',	me:'P201209'},
          //   3: {mn:'P201120',	me:'P201220', valor: 0},
          //   4: {mn:'P201121',	me:'P201221'},
          //   5: {mn:'P202101',	me:'P202201'},
          //   6: {mn:'P202103',	me:'P202203'},
          //   7: {mn:'P204101',	me:'P204201'},
          //   8: {mn:'P204102',	me:'P204202'},
          //   9: {mn:'P201112',	me:'P201212'},
          //   10: {mn:'P201113',	me:'P201213', valor:0},
          //   11: {mn: 'total', me: '', descripcion: 'Total flujos activos', operacion: 'suma'}
          // }
        } 
        break;
    }
    return composicionTablas;
  }

  static limiteRegulatorio(plantilla){
    switch(plantilla){
      case 13:
        let limites = [1,1.25,1.25]
        return limites;
      default: return {};
    }
  }
}